<template>
  <footer class="app-footer">
    <a
      href="https://boomerangweb.net"
      target="_blank"
    >
      Boomerang Web
    </a>
    <span>
      © {{ new Date().getFullYear() }} TDCLIC.
    </span>
  </footer>
</template>

<script>
export default {
  name: "MainFooter",
  components: {},
};
</script>
